import {z} from 'zod';
import {secondsOrMsSchema} from '../shared';
import {standardPlaybackControlSchema} from '../interaction/control';

/**
 * Schema for playback control settings.
 * Controls how a timeline plays when triggered, separate from animation timing.
 *
 * Used in three contexts:
 * 1. Trigger config (legacy, for single-timeline interactions)
 * 2. Timeline settings (new, for multi-timeline interactions)
 * 3. Conditional outcomes (for conditional logic)
 */
export const playbackSettingsSchema = z.object({
  /** Playback control action */
  control: standardPlaybackControlSchema.optional(),
  /** Delay before executing the control */
  delay: secondsOrMsSchema.optional(),
  /** Position to jump to when control executes */
  jump: secondsOrMsSchema.optional(),
  /**
   * Playback speed multiplier. `0` is the Designer Speed slider min; trigger
   * `config.speed` already uses `.nonnegative()` for the same bound.
   */
  speed: z.number().nonnegative().optional(),
});

export type PlaybackSettings = z.infer<typeof playbackSettingsSchema>;
